import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import SubscriptionRoute from '../../../components/routing/SubscriptionRoute';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { fetchOrganization, selectOrganization } from '../../../redux/organization/organizationSlice';
import { RowsSkeleton } from '../../ui';
import { V2_BASE } from '../../paths';
import type { OrgFeature, V2Guard } from './types';

/** 旧画面の FeatureRoute と同じ判定。フラグが無効なとき・組織を読めないときは新UIのホームへ戻す */
export const FeatureGate: React.FC<{ feature: OrgFeature; children: React.ReactNode }> = ({ feature, children }) => {
  const dispatch = useAppDispatch();
  const organization = useAppSelector(selectOrganization);
  const { isLoading, error } = useAppSelector((s) => s.organization);

  useEffect(() => {
    if (!organization && !isLoading && !error) dispatch(fetchOrganization());
  }, [dispatch, organization, isLoading, error]);

  if (!organization) {
    if (error) return <Navigate to={V2_BASE} replace />;
    return <RowsSkeleton rows={3} />;
  }
  if (!organization[feature]) return <Navigate to={V2_BASE} replace />;
  return <>{children}</>;
};

/** 経路の表（routes.ts）に書いた守りを掛ける。断ったときは新UIのホームへ戻す */
export const RouteGuard: React.FC<{ guard?: V2Guard; children: React.ReactNode }> = ({ guard, children }) => {
  if (!guard) return <>{children}</>;
  if (guard.kind === 'card') return <SubscriptionRoute redirectTo={V2_BASE}>{children}</SubscriptionRoute>;
  return <FeatureGate feature={guard.feature}>{children}</FeatureGate>;
};
